import { render, staticRenderFns } from "./life.vue?vue&type=template&id=2c12ecfa&scoped=true&"
import script from "./life.vue?vue&type=script&lang=js&"
export * from "./life.vue?vue&type=script&lang=js&"
import style0 from "./life.vue?vue&type=style&index=0&id=2c12ecfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c12ecfa",
  null
  
)

export default component.exports